// src/Header.js
import React, { useMemo } from 'react';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

function Header() {
  const { user, signOut, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Get user's display name or email
  const getUserDisplayName = () => {
    if (!user) return '';
    return user.user_metadata?.name || user.email || 'User';
  };

  // Check if user has access to statistics (ROE Visual employees only)
  const hasStatisticsAccess = useMemo(() => {
    if (!user) return false;

    const email = user.email?.toLowerCase() || '';
    const isRoeVisualEmail = email.endsWith('@roevisual.com');

    // Check if user authenticated via Azure SSO
    const isAzureUser = user.app_metadata?.provider === 'azure' ||
                        user.identities?.some(identity => identity.provider === 'azure');

    return isRoeVisualEmail || isAzureUser;
  }, [user]);

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand>
          ROE Visual Service
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {isAuthenticated && (
              <>
                <Nav.Link as={Link} to="/">
                  Home
                </Nav.Link>
                <Nav.Link as={Link} to="/search">
                  Barcode Search
                </Nav.Link>
                <Nav.Link as={Link} to="/batch-search">
                  Batch Search
                </Nav.Link>
                {hasStatisticsAccess && (
                  <Nav.Link as={Link} to="/statistics">
                    Statistics
                  </Nav.Link>
                )}
                <Nav.Link as={Link} to="/help">
                  Help
                </Nav.Link>
              </>
            )}
          </Nav>

          {isAuthenticated && (
            <Nav>
              <NavDropdown
                title={getUserDisplayName()}
                id="user-dropdown"
                align="end"
              >
                <NavDropdown.Item disabled>
                  {user?.email}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleSignOut}>
                  Sign Out
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
